import { BasicSelect } from 'vue-search-select';
import MasterService from './../../../services/masterdata.service';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../shared/constants/constant';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Papa from "papaparse";
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination';

export default {
	name: 'TariffCard',
	components: {
		BasicSelect,
		VueElementLoading,
		Treeselect,CustomExpandableTable,Pagination
	},
	props: ['selectedEditRowData'],
	data: function () {
		return {
			updateID: '',
			validatedData: [],
			matrixSlabHeaderArray: [],
			tariffcardName: '',
			tariffcardDescription: '',
			servicelist: [],
			tableColumnSlab:['Sheet Row Number','Origin Region','Origin State','Origin City', 'Origin Territory',
			'Destination Region','Destination State','Destination City', 'Destination Territory',
			'Route Mode','Rate basis','Rate Type','Slab Type','Slab Break','Rate per basis (INR)','Invalid Reason'],
			tableColumnFlat:['Sheet Row Number','Origin Region','Origin State','Origin City',
			'Destination Region','Destination State','Destination City',
			'Route Mode','Rate basis','Rate Type','Rate per basis (INR)','Invalid Reason'],
			selectedservice: {
				label: '',
				id: null
			},
			service: '',
			ratetype: '',
			showmatrix: false,
			showslabtemp: false,
			slablist: [],
			selectedslab: {
				label: '',
				id: null
			},
			slabtype: '',
			serviceChangedFlag:1,
			slabChangedFlag:1,
			selectedTemplate: {
				id: null,
				label: ''
			},
			SYMBOL_CONFIG: {
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
			},
			isLoading: false,
			selectedEditRowDataEdit: '',
			check: true,
			disabled: false,
			seriveLevelTemplateName: '',
			serviceLevelTemplateDescription: '',
			selectedTemplate: {
				id: null,
				label: ''
			},
			serviceLevelId: null,
			tariffcardratebasis: '',
			tariffcardslabtype: '',
			slabMaster: [],
			selectedSlabDetails: '',
			routeMode:'Surface',
			serviceMaster:[],
			serviceTemplateCount: 0,
			userid:"",
      		userreferencestring: "",
			servicetype : 2,
			arrOfMatrix : [],
			SlabDetailsToSave:[]
		}
	},
	computed: {},
	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
		this.userid = userdetail.userid;
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let text = "";
    for (let i = 0; i < 3; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    let uniquerefno = this.userid+text;
    this.userreferencestring = uniquerefno;
		this.isLoading = true;
		await Promise.all([
			this.getSlabList(),
			this.getServiceAreaTemplateList()
		]);
		await this.filterServiceList();
		this.isLoading = false;
		if (this.selectedEditRowData.id) {
			this.updateID = this.selectedEditRowData.id;
			this.isLoading = true;
			await this.getOldslabDeatils();
			await Promise.all([
				this.getDetailsTarrifCard(this.selectedEditRowData.id)
			]);
		 this.isLoading = false;
		} else {
			this.updateID = '';
		}
		await this.getZonenamesdata()
	},
	methods: {
		async getOldslabDeatils(){
			try {
				this.isLoading = true;
				let result = await MasterService.getUploadedSlabDetails({tariffcardid:this.updateID});
				if(result.data.code == 200){
					this.getOldSlabDetailsArray = result.data.data;
				}
			} catch (error) {
				this.isLoading = false;
				console.log(error)
			}
		},
		setName(data, index) {
			return data + index;
		},
		setDownloadLabel() {
			if (this.updateID) {
				let conpare = this.ratetype == 'flat' ? 1 : 2;
				if (this.serviceChangedFlag && this.updateID == this.selectedEditRowDataEdit.id && conpare == this.selectedEditRowDataEdit.tariffcardtype && this.selectedservice.id == this.selectedEditRowDataEdit.servicelevelid && this.tariffcardratebasis == this.selectedEditRowDataEdit.ratebasis) {
					if (this.ratetype == 'flat') {
						this.validatedData[0].downloadLabel = 'Download Rate';
					} else {
						if (this.slabChangedFlag && this.selectedslab.id == this.selectedEditRowDataEdit.tariffcarddetails.slabid) {
							for (let i = 0; i < this.validatedData.length; i++) {
								if (this.getOldSlabDetailsArray.some(el => el.slabnumber == this.validatedData[i].slabnumber)) {
									this.validatedData[i].downloadLabel = 'Download Rate';
								}
							}
						}
					}
				}
			};
		},
		resetFiles(index) {
			this.validatedData[index].isvalidation = false;
			this.validatedData[index].isfilechose = false;
			this.validatedData[index].validdata = 0;
			this.validatedData[index].invaliddata = 0;
			this.validatedData[index].tableItems = [];
			this.validatedData[index].totalPage = 0;
			this.validatedData[index].currentPage =  1;
			this.validatedData[index].totalCount = 0;
			this.validatedData[index].offset =  0;
			this.validatedData[index].pageLimit = 10;
			this.validatedData[index].totalrecords = 0;
			this.validatedData[index].isvalidationdone = false;
			this.validatedData[index].file = null;
			this.validatedData[index].filename = null;
			this.validatedData[index].isDisable = true;
			this.validatedData[index].notpresentdata = 0;
		},
		async downloadInvalidData(index) {
			try {
				this.isLoading = true;
        let inputPayload = {}
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
				if(this.ratetype=='slab'){
					inputPayload.slabnumber = index+1;
				}
        let result = await MasterService.getInvalidRateTATForDownload(inputPayload);
				let data = result.data.data.rows;
				let tempData = [];
				data.forEach(el => {
					let obj = {
						id: el.id,
						'Sheet Row Number': el.sheetid,
						'Origin Region':el.originregion,
						'Origin State': el.originstate,
						'Origin City':el.origincity,
						'Origin Territory':el.originterritory,
						'Destination Region':el.destinationregion,
						'Destination State':el.destinationstate,
						'Destination City':el.destinationcity,
						'Destination Territory':el.destinationterritory,
						'Route Mode':el.travelmode,
						'Rate basis': el.ratebasis,
						'Rate Type': el.ratetype,
						'Rate per basis (INR)': el.rateperbasis,
						'Invalid Reason':el.comment,
					}
					if (this.ratetype == 'slab') {
						obj['Slab Type'] = el.slabtype,
						obj['Slab Break'] = el.slabbreak.toString();
					}
					tempData.push(obj);
				})
				this.makeXls(tempData,'Invalid Tariff.csv');
				this.isLoading = false;
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
		async makeXls(xlsdata,name,flag){
			var blob = new Blob([Papa.unparse(xlsdata)], { type: 'text/csv;charset=utf-8;' });
			if(flag) return new File([blob],name);
			var link = document.createElement("a");
			var url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", name);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			return
		},
		filterSlabList() {
			this.matrixSlabHeaderArray = [];
			let filterFlag = this.tariffcardslabtype == 1 ? CONSTANT.SLAB_TYPE.WEIGHT : CONSTANT.SLAB_TYPE.QUANTITY;
			this.slablist = this.slabMaster.filter(slab => slab.slabType == filterFlag);
			let flag = 0;
			for (let i = 0; i < this.slablist.length; i++) {
				if (this.slablist[i].id == this.selectedslab.id) {
					flag = 1;
					break;
				}
			}
			if (!flag) {
				this.selectedslab.id = null;
				this.selectedslab.label = '';
			}
			this.setDownloadLabel();
		},
		async downloadUploadedData(val) {
			try {
				this.isLoading = true;
				let serviceData;
				let resultArr = [];
				let result;
				if (val) {
					let payload = {
						tariffcardid:this.selectedEditRowDataEdit.id,
						slabsequence:val.slabDetails.slabnumber
					}
					let countResult = await MasterService.getTariffDetailsCount(payload);
					let count = Number(countResult.data.data);
					let limit = 30000;
					let offset = 0;
					let tatlist = [];
					let loop =  Math.ceil(count / limit);
					for (let i = 0; i < loop; i++) {
					  payload.limit = limit;
					  payload.offset = offset;
					  result = await MasterService.getTariffDetailsForDownload(payload);
					  resultArr = resultArr.concat(result.data.data)  
					  offset = offset + limit;
						  }  
					if(resultArr.length > 0){
						serviceData = resultArr;
					}else{
						return false;
					}
					if (serviceData.length < 1) return false;
				} else {
					let payload = {
						tariffcardid:this.selectedEditRowDataEdit.id,
					}
					let countResult = await MasterService.getTariffDetailsCount(payload);
					let count = Number(countResult.data.data);
					let limit = 30000;
					let offset = 0;
					let tatlist = [];
					let loop =  Math.ceil(count / limit);
					for (let i = 0; i < loop; i++) {
					  payload.limit = limit;
					  payload.offset = offset;
					  result = await MasterService.getTariffDetailsForDownload(payload);
					  resultArr = resultArr.concat(result.data.data)  
					  offset = offset + limit;
						  } 
					serviceData = resultArr;
				}
				let downloadData = [];
				if(this.selectedEditRowDataEdit.servicetype==2)
				 {
				 downloadData = this.createMatrixforZonetoZone(resultArr)
				 }
				 else{
					serviceData.forEach(item => {
						let obj = {
							'Origin Region': item.originregion,
							'Origin State': item.originstate,
							'Origin City': item.origincity,
							'Origin Territory': item.originterritory,
							'Destination Region': item.destinationregion,
							'Destination State': item.destinationstate,
							'Destination City': item.destinationcity,
							'Destination Territory': item.destinationterritory,
							'Route Mode': item.travelmode,
							'Rate basis': this.selectedEditRowDataEdit.ratebasis == 1 ? 'Weight' : 'Quantity',
							'Rate Type Flat/Slab': this.selectedEditRowDataEdit.tariffcardtype == 1 ? 'Flat' : 'Slab',
						}
						if (this.selectedEditRowDataEdit.tariffcardtype == 2) {
							obj['Slab Type (Weight/ Quantity)'] = this.selectedEditRowDataEdit.slabtype == 1 ? "Weight" : "Quantity";
							obj["Slab Break (Low - High)"] = parseInt(item.lowerlimitvalue) + ' to ' + parseInt(item.higherlimitvalue);
						}
						obj['Rate per basis (INR)'] = item.tariffrate;
						downloadData.push(obj);
					});
				 }
				this.makeXls(downloadData,'Tariff.csv');
				this.isLoading = false;
				return true;
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
		async downloadTariff(val, dataCompare) {
			try {
				if (this.updateID && !dataCompare) {
					let conpare = this.ratetype == 'flat' ? 1 : 2;
					if (this.serviceChangedFlag && this.updateID == this.selectedEditRowDataEdit.id && conpare == this.selectedEditRowDataEdit.tariffcardtype && this.selectedservice.id == this.selectedEditRowDataEdit.servicelevelid && this.tariffcardratebasis == this.selectedEditRowDataEdit.ratebasis) {
						if (conpare == 2 && this.slabChangedFlag) {
							if (this.selectedslab.id == this.selectedEditRowDataEdit.tariffcarddetails.slabid) {
								let flag = await this.downloadUploadedData(val);
								if (flag) return;
							}
						} else if (conpare == 1) {
							await this.downloadUploadedData();
							return;
						}
					}
				}
				this.isLoading = true;
				let payload = {
					servicelevelid: this.selectedservice.id
				}
				let countResult = await MasterService.getServiceLevelCount(payload);
				let serviceTemplateCount = Number(countResult.data.data);
				let limit = 30000;
				let offset = 0;
				let tatlist = [];
				let loop =  Math.ceil(serviceTemplateCount / limit);
				for (let i = 0; i < loop; i++) {
				  payload.limit = limit;
				  payload.offset = offset;
				  let result = await MasterService.getServiceLevelDetail(payload);   
				  offset = offset + limit;
				  tatlist = tatlist.concat(result.data.data.rows)
				}
				// let result = await MasterService.getServiceLevelDetail(payload);
				let serviceData = [];
				function capitalizeFirstLetter(string) {
					return string.charAt(0).toUpperCase() + string.slice(1);
				}
				this.serviceTemplateCount = serviceTemplateCount;
				if (this.servicetype == 2) {
					let data = this.createMatrixforZonetoZone(tatlist)
					this.makeXls(data,'Tariff.csv');
				}else{
					tatlist.forEach(item => {
						let obj = {
							'Origin Region': item.originregion,
							'Origin State': item.originstate,
							'Origin City': item.origincity,
							'Origin Territory': item.originterritory,
							'Destination Region': item.destinationregion,
							'Destination State': item.destinationstate,
							'Destination City': item.destinationcity,
							'Destination Territory': item.destinationterritory,
							'Route Mode': item.travelmode,
							'Rate basis': this.tariffcardratebasis == 1 ? 'Weight' : 'Quantity',
							'Rate Type Flat/Slab': capitalizeFirstLetter(this.ratetype),
						}
						if (this.ratetype == 'slab') {
							obj['Slab Type (Weight/ Quantity)'] = this.tariffcardslabtype == 1 ? "Weight" : "Quantity";
							obj["Slab Break (Low - High)"] = val.xlsDetails.toString();
						}
						if (dataCompare) {
								obj.originstateid = item.originstateid;
								obj.origincityid = item.origincityid;
								obj.destinationstateid = item.destinationstateid;
								obj.destinationcityid = item.destinationcityid;
						}
						obj['Rate per basis (INR)'] = "";
						serviceData.push(obj);
					});
					if (dataCompare) {
						return serviceData;
					}
					this.makeXls(serviceData,'Tariff.csv');
				}
				
				this.isLoading = false;
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		 createMatrixforZonetoZone(data) {
			// Define the list of zones and initialize an empty matrix
			const matrix = {};
		  
			// Initialize the matrix with zeros
			const matrixArray = this.zones.map((origin) => {
				const row = { '': origin };
				this.zones.forEach((destination) => {
				  const foundItem = data.find(item => item.origincity === origin && item.destinationcity === destination);
				  row[destination] = foundItem ? (foundItem.tariffrate?foundItem.tariffrate:0) : null;
				});
				return row;
			  });
		  
			return matrixArray;
		  },
		resetForm(){
			this.setDownloadLabel();
			this.tariffcardratebasis= '';
			this.ratetype='';
			this.tariffcardslabtype='';
			this.matrixSlabHeaderArray = [];
			this.selectedslab = {
				label: '',
				id: null
			}
			this.slabtype = '';
		},
		changeRoute(){
			this.resetForm();
			this.selectedservice = { label: '', id: null };
			this.filterServiceList();
		},
		async chooseFile(e, index, isSlab=0) {
			try {
				this.validatedData[index].isupload = 0;
				this.validatedData[index].validdata = 0;
				this.validatedData[index].invaliddata = 0;
				this.validatedData[index].tableItems = [];
				this.validatedData[index].totalPage = 0;
				this.validatedData[index].currentPage =  1;
				this.validatedData[index].totalCount = 0;
				this.validatedData[index].offset =  0;
				this.validatedData[index].pageLimit = 10;
				this.validatedData[index].notpresentdata=0;
				const files = e.target.files;
				if (!files.length) {
					this.$refs.files.value = null;
					return;
				} else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
					this.$refs.files.value = null;
					return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
				}else{
					this.validatedData[index].file = e.target.files[0];
					this.validatedData[index].filename = e.target.files[0].name;
					this.validatedData[index].isfilechose = true;
					this.validatedData[index].isvalidationdone = false;
				  this.validatedData[index].isDisable = false;
					if(isSlab){
						this.$refs.files[index].value = null;
					}else{
						this.$refs.files.value = null;
					}
					if (this.servicetype == 1) {
					await this.parseFile(index, isSlab);
					}else if(this.servicetype == 2){
						await this.parseZoneToZoneFile(index,isSlab)
					}
				}
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		async parseFile(index, isSlab){
      let userid = this.userid;
      let userreferencestring = this.userreferencestring;
      var count = 0; // cache the running count
      var csvData=[];
      var sheetid = 1;
      var validheader = 1;
      Papa.parse( this.validatedData[index].file, {
          header: true,
          skipEmptyLines: true,
          before: this.isLoading = true,
          worker: true, // Don't bog down the main thread if its a big file
          step: function(result) {
            let fileHeaders = result.meta.fields;
						if(isSlab && fileHeaders.length!=14){
							validheader = 0;
						}else if(!isSlab && fileHeaders.length!=12){
							validheader = 0;
						}else if(isSlab && sheetid==1 && (!fileHeaders.includes("Origin Region") ||
							!fileHeaders.includes("Origin State") ||
							!fileHeaders.includes("Origin City") ||
							!fileHeaders.includes("Origin Territory") ||
							!fileHeaders.includes("Destination Region") ||
							!fileHeaders.includes("Destination State") ||
							!fileHeaders.includes("Destination City") ||
							!fileHeaders.includes("Destination Territory") ||
							!fileHeaders.includes("Route Mode") ||
							!fileHeaders.includes("Rate basis") ||
							!fileHeaders.includes("Rate Type Flat/Slab") ||
							!fileHeaders.includes("Slab Type (Weight/ Quantity)") ||
							!fileHeaders.includes("Slab Break (Low - High)") ||
							!fileHeaders.includes("Rate per basis (INR)"))){
							validheader = 0;
						}else if(sheetid==1 && !fileHeaders.includes("Origin Region") ||
	              !fileHeaders.includes("Origin State") ||
	              !fileHeaders.includes("Origin City") ||
	              !fileHeaders.includes("Origin Territory") ||
	              !fileHeaders.includes("Destination Region") ||
	              !fileHeaders.includes("Destination State") ||
	              !fileHeaders.includes("Destination City") ||
	              !fileHeaders.includes("Destination Territory") ||
	              !fileHeaders.includes("Route Mode") ||
	              !fileHeaders.includes("Rate basis") ||
	              !fileHeaders.includes("Rate Type Flat/Slab") ||
	              !fileHeaders.includes("Rate per basis (INR)")){
								validheader = 0;
							}
							sheetid ++;
	            let tempResult = {};
              tempResult.originregion = (result.data['Origin Region'])?result.data['Origin Region']:null;
              tempResult.originstate = (result.data['Origin State'])?result.data['Origin State']:null;
              tempResult.origincity = (result.data['Origin City'])?result.data['Origin City']:null;
              tempResult.originterritory = (result.data['Origin Territory'])?result.data['Origin Territory']:null;
              tempResult.destinationregion = (result.data['Destination Region'])?result.data['Destination Region']:null;
              tempResult.destinationstate = (result.data['Destination State'])?result.data['Destination State']:null;
              tempResult.destinationcity = (result.data['Destination City'])?result.data['Destination City']:null;
              tempResult.destinationterritory = (result.data['Destination Territory'])?result.data['Destination Territory']:null;
              tempResult.travelmode = (result.data['Route Mode'])?result.data['Route Mode']:null;
              tempResult.ratebasis = (result.data['Rate basis'])?result.data['Rate basis']:null;
              tempResult.ratetype = (result.data['Rate Type Flat/Slab'])?result.data['Rate Type Flat/Slab']:null;
							if(isSlab){
								tempResult.slabtype = (result.data['Slab Type (Weight/ Quantity)'])?result.data['Slab Type (Weight/ Quantity)']:null;
								tempResult.slabbreak = (result.data['Slab Break (Low - High)'])?result.data['Slab Break (Low - High)']:null;
								tempResult.slabsequence = index+1;
							}
              tempResult.rateperbasis = (result.data['Rate per basis (INR)'])?result.data['Rate per basis (INR)']:null;
              tempResult.status = 0;
              tempResult.userid = userid;
              tempResult.userreferencestring = userreferencestring;
              tempResult.sheetid = sheetid;
	            csvData.push(tempResult);
          },
          complete: function(){
            if(validheader==0){
							this.isLoading = false;
							this.resetFiles(index);
              return this.$alert('File headers are not matched. Please download Tariff card csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
            }else if(csvData.length<1){
							this.isLoading = false;
							this.resetFiles(index);
              return this.$alert('Tariff file data should not be blank. At least one record set is required.', "", "error");
            }else if(this.serviceTemplateCount != csvData.length){
							this.isLoading = false;
							this.resetFiles(index);
              return this.$alert('Selected file total records were not matched with Download Rate Template total records.', "", "error");
						}else{
							this.validatedData[index].totalrecords = csvData.length;
              this.chunkArray(csvData, 20000, index, isSlab);
            }
          }.bind(this)
      } );
	  this.isLoading = false
    },
	async parseZoneToZoneFile(index,isSlab){
		try {
			let tempArr = []
			Papa.parse(this.validatedData[index].file, {
			  header: true, // Assumes the first row contains column headers
			  dynamicTyping: true, // Automatically convert values to their appropriate types
			  before: this.isLoading = true,
			  skipEmptyLines: true,
			  complete: function (result) {
				console.log("result.errors",result.errors);
		  
				let data = result.data;
	  
				// Create an object to store the JSON data
		  
				// Iterate through the rows and columns to create the JSON
			    if (data.length>18) {
				this.isinvalid=true
			   return this.$alert('Invalid 18 x18 template :File headers mismached Origin Zones shold be maximum 18', "", "error");
				  }
				for (let i = 0; i < data.length; i++) {
				  let row = data[i];
				  let rowName = row['']; // Row name is in the first column
				  if(Object.keys(row).length>19)
				  {
				   return this.$alert('Invalid 18 x18 template :File headers mismached Destination Zones shold be maximum 18', "", "error");
				  }
				if(Object.keys(row)[0] )
				  {
					this.isLoading = false
					return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
				  }
				if(  !this.zones.includes(rowName))
				  {
					this.isLoading = false
					return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
				  }
				  for (const colName in row) {
					const keysArray = Object.keys(row);
					if( keysArray.indexOf(colName)!=0 && !this.zones.includes(colName))
					{
					 this.isLoading = false
					 return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
					}
					if (colName !== '' && row[colName] != null) {
					  let zoneName = colName;
					  tempArr.push({originzone : rowName , destinationzone :zoneName , TAT : row[colName] })
					}
				  }
				}
			  }.bind(this)
			});
			this.arrOfMatrix[index] = tempArr
			this.isLoading = false
		} catch (err) {
			console.log(err);
		}
	},
	async chunkArray(myArray, chunk_size, slabindex, isSlab){
      try {
        await this.deletePreviousUploadRatesTAT(slabindex, isSlab);
        var index = 0;
        var arrayLength = myArray.length;
        let tempArr = [];
        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index+chunk_size);
            await this.uploadRateFile(myChunk, isSlab);
        }
        this.$alertify.success("File data uploaded Successfully");
        this.isLoading = false;
      }catch (err){
        console.log(err);
      }
    },
    async deletePreviousUploadRatesTAT(slabindex, isSlab){
      try{
        this.isLoading = true;
        var inputPayload = {};
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        inputPayload.slabindex = (isSlab)?slabindex+1:null;
        let result = await MasterService.deletePreviousUploadRateTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
	async uploadRateFile(filechunkdata){
      try{
        var inputPayload = {};
        inputPayload.file = filechunkdata;
        let result = await MasterService.uploadRateTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
	async validateTariff(val, index) {
		try {
			if (this.servicetype == 1) {
				this.isLoading = true;
				var inputPayload = {};
        inputPayload.routemode = this.routeMode;
        inputPayload.rateType = this.ratetype;
        inputPayload.serviceLevelId = this.selectedservice.id;
        inputPayload.ratebasis = this.tariffcardratebasis;
				if(this.ratetype == 'slab'){
					inputPayload.slabType = this.tariffcardslabtype;
					inputPayload.slabid = this.selectedslab.id;
					inputPayload.slabnumber = val.id;
					let breaktitle = this.matrixSlabHeaderArray[index].slabDetails;
					inputPayload.slabbreak = parseInt(breaktitle.lowerlimitvalue)+' to '+parseInt(breaktitle.higherlimitvalue);
				}
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        let result = await MasterService.validateTariff(inputPayload);
        this.isLoading = false;
				if (result.data.code == 200) {
					let resultData = result.data.data;
					this.validatedData[index].isupload = 1;
					let successCount = 0;
          let failedCount = 0;
          resultData.forEach((element) => {
              if(element.status==1){
                successCount = element.count;
              }
              if(element.status==2){
                failedCount = element.count;
              }
          });
					this.validatedData[index].isvalidationdone = true;
					this.validatedData[index].validdata = parseInt(successCount);
					this.validatedData[index].invaliddata = parseInt(failedCount);
					this.validatedData[index].currentPage = 1;
					this.validatedData[index].pageLimit = 10;
					this.validatedData[index].offset = 0;
					this.validatedData[index].totalCount = parseInt(failedCount);
					this.validatedData[index].totalPage = Math.ceil(parseInt(failedCount) / this.validatedData[index].pageLimit);
					this.setInvalidData(index);
				} else {
					this.validatedData[index].isupload = 0;
					this.validatedData[index].validdata = 0;
					this.validatedData[index].invaliddata = 0;
					this.$alert(result.data.message, this.seriveLevelTemplateName, "error");
				}
				this.validatedData[index].isDisable = true;	
			}else if(this.servicetype == 2){
				var inputPayload = {};
				inputPayload.serviceLevelId = this.selectedservice.id
				inputPayload.arrOfMatrix = this.arrOfMatrix[index]
				this.validatedData[index].totalCount = this.arrOfMatrix[index].length
				this.validatedData[index].totalrecords = this.arrOfMatrix[index].length
				this.validatedData[index].isupload = 1;
				this.validatedData[index].isvalidationdone = true;
				let result = await MasterService.validateTariffRate18x18(inputPayload);
				if (result.data.code == 200) {
					this.validatedData[index].invaliddata = 0;
					this.validatedData[index].validdata  = this.validatedData[index].totalCount
				}else{
					this.validatedData[index].invaliddata = result.data.data.invalid18x18Data.length;
					this.validatedData[index].validdata = this.validatedData[index].totalCount - this.validatedData[index].invaliddata
					this.validatedData[index].invalid18x18Data = result.data.data.invalid18x18Data
					this.validatedData[index].notpresentdata=result.data.data.notpresentrecords.length
					this.validatedData[index].isvalidationdone = true;
					if(result.data.data.notpresentrecords.length>0)
					{
						(this.validatedData[index].invalid18x18Data).push(...result.data.data.notpresentrecords)
					}
				}
			}
		} catch (error) {
						this.isLoading = false;
			console.log(error);
		}
	},
		onPageChange(page,index) {
			this.validatedData[index].currentPage = page;
			this.validatedData[index].offset = (page - 1) * this.validatedData[index].pageLimit;
			this.setInvalidData(index);
		  },
		async setInvalidData(index){
			try {
					this.isLoading = true;
					let inputPayload = {
						"offset": this.validatedData[index].offset,
						"limit": this.validatedData[index].pageLimit,
					}
					inputPayload.userid = this.userid;
					inputPayload.userreferencestring = this.userreferencestring;
					if(this.ratetype=='slab'){
						inputPayload.slabsequence = index+1;
					}
					let result = await MasterService.getInvalidRateTATListing(inputPayload);
					this.isLoading = false;
					this.validatedData[index].tableItems = [];
					let data = result.data.data.rows;
					data.forEach(el => {
						let obj = {
							id: el.id,
							'Sheet Row Number': el.sheetid,
							'Origin Region':el.originregion,
							'Origin State': el.originstate,
							'Origin City':el.origincity,
							'Origin Territory':el.originterritory,
							'Destination Region':el.destinationregion,
							'Destination State':el.destinationstate,
							'Destination City':el.destinationcity,
							'Destination Territory':el.destinationterritory,
							'Route Mode':el.travelmode,
							'Rate basis': el.ratebasis,
							'Rate Type': el.ratetype,
							'Rate per basis (INR)': el.rateperbasis,
							'Invalid Reason':el.comment,
						}
						if (this.ratetype == 'slab') {
							obj['Slab Type'] = el.slabtype,
							obj['Slab Break'] = el.slabbreak.toString();
						}
						this.validatedData[index].tableItems.push(obj);
					})
				} catch(err){
					this.isLoading = false;
					console.log(err);
				}
		},
		async getDetailsTarrifCard(tariffcardid, NoupdateForm) {
			try {
				this.isLoading = true;
				let result = await MasterService.getBasicTariffData({
					tariffcardid: tariffcardid
				});
				this.selectedEditRowDataEdit = result.data.data.tariffmaster;
				this.selectedEditRowDataEdit.tariffcarddetails = result.data.data.tariffdetails;
				if (NoupdateForm) return;
				this.setSaveFormDetails();
			} catch (err) {
				this.isLoading = false;
				console.log(err);
				return;
			}
		},
		setSaveFormDetails() {
			this.tariffcardName = this.selectedEditRowDataEdit.tariffcardname;
			this.tariffcardDescription = this.selectedEditRowDataEdit.tariffcarddescription;
			this.selectedservice.id = this.selectedEditRowDataEdit.servicelevelid;
			this.serviceLevelId = this.selectedservice.id;
			this.tariffcardratebasis = this.selectedEditRowDataEdit.ratebasis;
			this.tariffcardslabtype = this.selectedEditRowDataEdit.slabtype;
			this.routeMode = this.selectedEditRowDataEdit.routemode;
			this.servicetype = this.selectedEditRowDataEdit.servicetype;
			this.selectedslab.id = this.selectedEditRowDataEdit.tariffcarddetails.slabid;
			this.filterServiceList();
			for (var i = 0; i < this.servicelist.length; i++) {
				if (this.servicelist[i].id == this.selectedEditRowDataEdit.servicelevelid) {
					this.selectedservice.label = this.servicelist[i].label;
					break;
				}
			}
			if (this.selectedEditRowDataEdit.tariffcardtype == CONSTANT.ACCESSORIAL_RATE_TYPE.FLAT) {
				this.createMatrixFromAlreadyExistData('flat');
				this.serviceTemplateCount = this.selectedEditRowDataEdit.tariffcarddetails.totalRecords;
				this.ratetype = 'flat';
				this.showmatrix = true;
				this.showslabtemp = false;
				this.selectedslab = {
					label: '',
					id: null
				}
				this.slabtype = '';
				this.validatedData = [{
					isupload: 0,
					validdata: 0,
					invaliddata: 0,
					tableItems : [],
					downloadLabel:'Download Rate Template',
					totalPage : 0,
					currentPage :  1,
					totalCount : 0,
					offset :  0,
					pageLimit : 10,
					totalrecords: 0,
					isvalidationdone: false,
					isfilechose: false,
					file: '',
					filename: ''
				}];
				this.setDownloadLabel();
			} else if (this.selectedEditRowDataEdit.tariffcardtype == CONSTANT.ACCESSORIAL_RATE_TYPE.SLAB) {
				this.serviceTemplateCount = this.selectedEditRowDataEdit.tariffcarddetails.totalRecords;
				this.check = false;
				this.ratetype = 'slab';
				this.showmatrix = false;
				this.showslabtemp = true;
				this.selectedslab.id = this.selectedEditRowDataEdit.tariffcarddetails.slabid;
				this.slabtype = this.selectedEditRowDataEdit.tariffcarddetails.slabid;
				this.slablist.forEach((el) => {
					if (el.id == this.selectedEditRowDataEdit.tariffcarddetails.slabid) {
						this.selectedslab.label = el.label
					}
				});
				let filterFlag = this.tariffcardslabtype == 1 ? CONSTANT.SLAB_TYPE.WEIGHT : CONSTANT.SLAB_TYPE.QUANTITY;
				this.slablist = this.slabMaster.filter(slab => slab.slabType == filterFlag);
				this.createMatrixFromAlreadyExistData('slab');
			}
		},
		async createMatrixFromAlreadyExistData(type) {
			if (this.selectedEditRowDataEdit.tariffcarddetails) {
				if (type == 'slab') {
					this.getSlabDetailsUpdate(this.selectedslab.id,this.getOldSlabDetailsArray);
					this.isLoading = false;
				} else if (type == 'flat') {
					this.isLoading = false;
				}
			}
		},
		async getServiceAreaTemplateList() {
			try {
				this.isLoading = true;
				let payload={}
				let result = await MasterService.getServiceLevelDropdown(payload);
				this.serviceMaster = [];
				if (result.data.code == 200) {
					this.serviceMaster = result.data.data.rows;
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async filterServiceList() {
			this.servicelist = [];
			this.serviceMaster.forEach(item => item.routemode == this.routeMode && item.servicetype == this.servicetype && this.servicelist.push({
				label: item.servicelevelname,
				id: item.id,
				isDisabled: item.status == 0 ? true : false
			}));
		},
		async selectservice(event) {
			try {
				this.isLoading = true;
				this.selectedservice.label = event.label;
				this.selectedservice.id = event.id;
				this.serviceLevelId = this.selectedservice;
				let payload = {
					servicelevelid: this.selectedservice.id
				}
				let result = await MasterService.getServiceLevelCount(payload);
				if(result.data.code == 200){
				this.serviceTemplateCount = Number(result.data.data);
				}
				this.getSelectedTemplateInfo(event.id);
				this.serviceChangedFlag = 0;
				this.resetForm();
				this.isLoading = false;
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
		async getSelectedTemplateInfo(id) {
			try {
				this.matrixSlabHeaderArray = [];
				if (this.selectedslab.id) {
					this.getSlabDetails(this.selectedslab.id);
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async getSlabList() {
			try {
				let weightInputPayload = {
					slabtype: CONSTANT.SLAB_TYPE.WEIGHT
				}
				let distanceInputPayload = {
					slabtype: CONSTANT.SLAB_TYPE.QUANTITY
				}
				this.isLoading = true;
				let result = await Promise.all([MasterService.getAllSlab(weightInputPayload),
				MasterService.getAllSlab(distanceInputPayload)]);
				let data = [...result[0].data.data, ...result[1].data.data];
				data.forEach(element => {
					this.slabMaster.push({
						id: element.id,
						label: element.slabname,
						isDisabled: element.status == 0 ? true : false,
						slabType: element.slabtype
					});
				});
				this.slablist = this.slabMaster;
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		selectslab(slab) {
			this.selectedslab = slab;
			this.slabtype = slab.id;
			this.slabChangedFlag = 0;
			this.getSlabDetails(slab.id);
		},
		async getSlabDetails(id, slabbreakupdetails) {
			try {
				if (this.check) {
					let weightInputPayload = {
						slabid: id
					}
					this.matrixSlabHeaderArray = [];
					this.isLoading = true;
					if (!slabbreakupdetails) {
						let result = await MasterService.getSlabDetails(weightInputPayload);
						slabbreakupdetails = result.data.data.slabbreakupdetails;
						this.SlabDetailsToSave=result.data.data;
						this.selectedSlabDetails = slabbreakupdetails;
					}
					this.isLoading = false;
					slabbreakupdetails.sort((a, b) => a.slabnumber - b.slabnumber).forEach((el) => {
						let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue},${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
						this.matrixSlabHeaderArray.push({
							id: el.slabnumber,
							name: name,
							xlsDetails: el.lowerlimitvalue + ' to ' + el.higherlimitvalue,
							slabDetails: el,
						});
					});
					this.validatedData = [];
					this.matrixSlabHeaderArray.forEach((item) => {
						let obj = {
							isupload: 0,
							validdata: 0,
							invaliddata: 0,
							tableItems : [],
							downloadLabel: 'Download Rate Template',
							slabnumber : item.id,
							totalPage : 0,
							currentPage :  1,
							totalCount : 0,
							offset :  0,
							pageLimit : 10,
							totalrecords: 0,
							isvalidationdone: false,
							isfilechose: false,
							file: '',
							filename: ''
						}
						this.validatedData.push(obj);
					});
					this.setDownloadLabel();
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async getSlabDetailsUpdate(id, slabbreakupdetails) {
			try {
				let weightInputPayload = {
					slabid: id
				}
				this.matrixSlabHeaderArray = [];
				this.isLoading = true;
				if (!slabbreakupdetails) {
					let result = await MasterService.getSlabDetails(weightInputPayload);
					slabbreakupdetails = result.data.data.slabbreakupdetails;
					this.selectedSlabDetails = slabbreakupdetails;
				}
				this.isLoading = false;
				slabbreakupdetails.sort((a, b) => a.slabnumber - b.slabnumber).forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue},${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
					this.matrixSlabHeaderArray.push({
						id: el.slabnumber,
						name: name,
						xlsDetails: el.lowerlimitvalue + ' to ' + el.higherlimitvalue,
						slabDetails: el,
					});
				});
				this.validatedData = [];
				this.matrixSlabHeaderArray.forEach((item) => {
					let obj = {
						isupload: 0,
						validdata: 0,
						invaliddata: 0,
						tableItems : [],
						downloadLabel : 'Download Rate Template',
						slabnumber:item.id,
						totalPage : 0,
						currentPage :  1,
						totalCount : 0,
						offset :  0,
						pageLimit : 10,
						totalrecords: 0,
						isvalidationdone: false,
						isfilechose: false,
						file: null,
						filename: null
					}
					this.validatedData.push(obj);
				});
				this.check = true;
				this.setDownloadLabel();
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		resetData(){
			this.setDownloadLabel();
			this.matrixSlabHeaderArray = [];
			this.selectedslab = {
				label: '',
				id: null
			}
			this.tariffcardslabtype = '';
			this.slablist = this.slabMaster;
			this.ratetype=''
		},
		showSlabWiseInput() {
			this.matrixSlabHeaderArray = [];
			this.selectedslab = {
				label: '',
				id: null
			}
			this.tariffcardslabtype = '';
			this.slablist = this.slabMaster;
			if (this.ratetype != '' && this.tariffcardratebasis != '') {
				if (this.ratetype == 'flat') {
					this.validatedData = [];
					this.validatedData.push({
						isupload: 0,
						validdata: 0,
						invaliddata: 0,
						tableItems : [],
						downloadLabel : 'Download Rate Template',
						totalPage : 0,
						currentPage :  1,
						totalCount : 0,
						offset :  0,
						pageLimit : 10,
						totalrecords: 0,
						isvalidationdone: false,
						isfilechose: false,
						file: null,
						filename: null
					});
					this.showmatrix = true;
					this.showslabtemp = false;
					this.$nextTick(() => {
						this.selectedslab = {
							label: '',
							id: null
						}
						this.slabtype = '';
					});
				} else {
					if (this.tariffcardratebasis == 1 && this.tariffcardslabtype == 2) this.tariffcardslabtype = null;
					this.validatedData = [];
					this.showmatrix = false;
					this.showslabtemp = true;
				}
				this.setDownloadLabel();
			}
		},
		showCreateTariffCard() {
			this.$emit("goBackToParent")
		},
		async saveAfterConfirm(){
			let result= [];
			try {
				this.isLoading = true;
				var inputPayload = {};
				inputPayload.lastmodifiedby = this.userName;
				inputPayload.tariffcardname = this.tariffcardName.trim();
				inputPayload.tariffcarddescription = this.tariffcardDescription.trim();
				inputPayload.servicelevelid = this.selectedservice.id;
				inputPayload.ratebasis = parseInt(this.tariffcardratebasis);
				inputPayload.routemode = this.routeMode;
				inputPayload.userid = this.userid;
        		inputPayload.userreferencestring = this.userreferencestring;
				inputPayload.servicetype=this.servicetype
				if (this.ratetype == 'flat') {
					if(this.servicetype==2)
					{
						inputPayload.arrOfMatrix=this.arrOfMatrix
					}
					inputPayload.tariffcardtype = CONSTANT.ACCESSORIAL_RATE_TYPE.FLAT;
				} else if (this.ratetype == 'slab') {
					if(this.servicetype==2)
					{
						inputPayload.arrOfMatrix=this.arrOfMatrix
                        inputPayload.slabdetails=this.SlabDetailsToSave.slabbreakupdetails
					}
					inputPayload.deleteFlatData = this.selectedEditRowDataEdit.ratebasis == 1 ? 1:0;
					inputPayload.tariffcardtype = CONSTANT.ACCESSORIAL_RATE_TYPE.SLAB;
					inputPayload.slabBreakCount = this.selectedSlabDetails.length;
					inputPayload.slabid = this.selectedslab.id;
					inputPayload.slabtype = this.tariffcardslabtype;
				}
				if (this.updateID) {
					inputPayload.tariffcardid = this.updateID;
				}
				let result = await MasterService.saveTariffCard(inputPayload);
				this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.tariffcardName, "success");
          this.$emit("goBackToParent");
        } else {
          this.$alert(result.data.message,this.tariffcardName, "error");
        }
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		async saveTariffCard() {
			try {
								let error = [];
				for (var index = 0; index < this.validatedData.length; index++) {
					if(this.validatedData[index].isvalidationdone == true &&
						this.validatedData[index].invaliddata == 0){
						continue;
					}else{
						error.push(this.matrixSlabHeaderArray[index].id);
					}
				}
				if(error.length > 0){
					this.$alert("Please Validate Rate for Slab Break "+error.join(", "), "", "error");
				}else{
					if(this.updateID){
					  var WarningMsg = "The old data will be overwritten by new data.Are you sure?";
					  this.$confirm(WarningMsg,"","question").then(()=>{
							this.saveAfterConfirm();
						}).catch((err)=>{
					  	console.log(err);
					  });
					}else{
						this.saveAfterConfirm();
					}
				}
			} catch (err) {
			  console.log(err);
			  this.isLoading = false;
			}
		},
		async validateTariffCard(){
						this.$validator.validateAll().then((result) => {
				if(result){
					this.saveTariffCard();
				}
			}).catch(() => {
				console.log('errors exist', this.errors);
			});
		},
		async changeServiceType(){
			this.resetForm();
			this.selectedservice = { label: '', id: null };
			this.getServiceAreaTemplateList()
		    await this.filterServiceList();
			this.isLoading = false;
		},
		async getZonenamesdata() {
			let inputpayload = {}
			let result = await MasterService.GetZoneNames(inputpayload);
			if (result.data.code == 200) {
				this.zones = result.data.data
			}
			else {
				this.$alertify.success("Zones Data not found");
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/tariffcard/createtariffcard/createtariffcard.component.js